// extracted by mini-css-extract-plugin
export default {"buttonsection":"SignUpForm_buttonsection__KYwPw","animationsection":"SignUpForm_animationsection__aS22W"};